import styled from "styled-components";

export const Container = styled.div`
  padding: 30px;
  margin: 20px;
  background: linear-gradient(135deg, #f5f9fc 0%, #ffffff 100%);
  min-height: 100vh;

  .header {
    display: flex;
    justify-content: space-between;
    .texts {
      h3 {
        font-size: 32px;
        line-height: 44px;
        color: #1a237e;
        background: linear-gradient(135deg, #03a9f4 0%, #0288d1 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }
      p {
        margin-top: 5px;
        line-height: 22px;
        font-size: 16px;
        color: #667085;
      }
    }

    .link-buttons {
      display: flex;
      gap: 10px;
      .see-more,
      .add-campaign {
        padding: 10px 16px;
        height: 40px;
        border: 1px solid #d0d5dd;
        border-radius: 8px;
        font-size: 14px;
        background-color: transparent;
        text-decoration: none;
        cursor: pointer;
        a {
          text-decoration: none;
          color: #344054;
        }
      }
      .add-campaign {
        a {
          color: #fff;
        }
        border: 1px solid #03a9f4;
        background-color: #03a9f4;
      }
    }
  }
  
  .submit {
    margin-top: 40px;
    padding-top: 30px;
    border-top: 2px solid #e3f2fd;
    display: flex;
    justify-content: flex-end;
    
    .submit-buttons {
      display: flex;
      gap: 12px;
      
      .cancel,
      .add-campaign {
        padding: 12px 24px;
        height: 44px;
        border-radius: 10px;
        font-size: 14px;
        font-weight: 500;
        background-color: transparent;
        text-decoration: none;
        cursor: pointer;
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      
      .cancel {
        color: #546881;
        border: 2px solid #e3f2fd;
        
        &:hover {
          border-color: #03a9f4;
          color: #03a9f4;
        }
      }
      
      .add-campaign {
        color: #fff;
        border: 2px solid #03a9f4;
        background: linear-gradient(135deg, #03a9f4 0%, #0288d1 100%);
        box-shadow: 0 2px 8px rgba(3, 169, 244, 0.3);
        
        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 16px rgba(3, 169, 244, 0.4);
        }
        
        &:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          transform: none;
        }
      }
    }
  }
  @media screen and (max-width: 820px) {
    width: 100%;
  }
`;

export const FormWrapper = styled.div`
  margin-bottom: 30px;
  padding: 25px 0;
  border-bottom: 1px solid #e3f2fd;
  
  &:last-of-type {
    border-bottom: none;
  }
  
  /* Grid layout for grouped fields - 2 columns */
  &.grid-row {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
    align-items: start;
    
    @media screen and (max-width: 768px) {
      grid-template-columns: 1fr;
      gap: 20px;
    }
  }
  
  /* Grid layout for 3 columns */
  &.grid-row-3 {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
    align-items: start;
    
    @media screen and (max-width: 1024px) {
      grid-template-columns: repeat(2, 1fr);
    }
    
    @media screen and (max-width: 768px) {
      grid-template-columns: 1fr;
      gap: 20px;
    }
  }
  
  /* Full width layout */
  &.full-width {
    display: block;
  }
  label {
    display: block;
    margin-bottom: 10px;
    color: #1a237e;
    font-size: 14px;
    font-weight: 600;
  }
  
  p {
    margin-top: 5px;
    margin-bottom: 15px;
    font-size: 13px;
    color: #546881;
    line-height: 1.5;
  }
  
  .date {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
    
    @media screen and (max-width: 568px) {
      grid-template-columns: 1fr;
    }
  }
  input[type="text"],
  input[type="file"],
  input[type="date"],
  input[type="number"] {
    width: 100%;
    margin-top: 10px;
    border: 2px solid #e3f2fd;
    border-radius: 10px;
    padding: 12px 16px;
    font-size: 14px;
    color: #1a237e;
    background: #ffffff;
    transition: all 0.3s ease;
    &:focus {
      outline: none;
      border-color: #03a9f4;
      box-shadow: 0 0 0 3px rgba(3, 169, 244, 0.1);
    }
    
    &::placeholder {
      color: #98a2b3;
    }
  }
  
  > div {
    margin-top: 10px;
  }
  
  /* Field wrapper for grid items */
  .field-group {
    display: flex;
    flex-direction: column;
  }
`;

export const SliderWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 20px;
  background: #f8fbff;
  border-radius: 10px;
  border: 2px solid #e3f2fd;
  margin-top: 10px;

  input[type="range"] {
    margin-right: 10px;
    background-color: #03a9f4;
  }
  
  span {
    white-space: nowrap;
    color: #03a9f4;
  }
`;

export const RadioGroup = styled.div`
  display: flex;
  flex-direction: row;
  gap: 30px;
  flex-wrap: wrap;
  margin-top: 10px;
  
  @media screen and (max-width: 568px) {
    flex-direction: column;
    gap: 15px;
  }
`;

export const CheckboxGroup = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-top: 10px;
  
  @media screen and (max-width: 568px) {
    grid-template-columns: 1fr;
  }
`;

export const ProofOfPaymentContainer = styled.div`
  border: 2px dashed #03a9f4;
  padding: 40px 20px;
  text-align: center;
  border-radius: 12px;
  background: #f8fbff;
  transition: all 0.3s ease;
  margin-top: 10px;
  
  &:hover {
    border-color: #0288d1;
    background: #e3f2fd;
  }
`;

export const FileInputLabel = styled.label`
  display: block;
  cursor: pointer;
  
  .text {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    color: #546881;
    
    img {
      opacity: 0.6;
    }
    
    p {
      font-size: 14px;
      font-weight: 500;
      color: #03a9f4;
      margin: 0;
    }
    
    small {
      font-size: 12px;
      color: #98a2b3;
    }
  }
`;

export const FileInput = styled.input`
  display: none;
`;

export const PreviewImage = styled.img`
  max-width: 100%;
  max-height: 300px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(3, 169, 244, 0.15);
`;

export const InputWrapper = styled.div`
  position: relative;
  margin-top: 10px;
  width: 100%;
  input {
    width: 100%;
    border: 2px solid #e3f2fd;
    border-radius: 10px;
    padding: 12px 16px;
    font-size: 14px;
    color: #1a237e;
    background: #ffffff;
    transition: all 0.3s ease;
    &:focus {
      outline: none;
      border-color: #03a9f4;
      box-shadow: 0 0 0 3px rgba(3, 169, 244, 0.1);
    }
  }
`;

export const Tooltip = styled.div`
  position: absolute;
  top: -90px;
  left: 0;
  background: #ffffff;
  border: 2px solid #03a9f4;
  border-radius: 10px;
  padding: 12px 16px;
  font-size: 13px;
  color: #1a237e;
  box-shadow: 0 4px 12px rgba(3, 169, 244, 0.2);
  white-space: nowrap;
  z-index: 10;
  min-width: 200px;
  &::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 20px;
    border: 8px solid transparent;
    border-top-color: #03a9f4;
  }
  strong {
    display: block;
    font-weight: 600;
    margin-bottom: 6px;
    color: #03a9f4;
  }
  p {
    margin: 0;
    font-size: 12px;
    color: #546881;
    line-height: 1.5;
  }
`;
